'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XoError = undefined;

var _startsWith2 = require('lodash/startsWith');

var _startsWith3 = _interopRequireDefault(_startsWith2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jsonrpcWebsocketClient = require('jsonrpc-websocket-client');

var _jsonrpcWebsocketClient2 = _interopRequireDefault(_jsonrpcWebsocketClient);

var _makeError = require('make-error');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// ===================================================================

var noop = function noop() {};

// ===================================================================

var XoError = exports.XoError = function (_BaseError) {
  _inherits(XoError, _BaseError);

  function XoError() {
    _classCallCheck(this, XoError);

    return _possibleConstructorReturn(this, (XoError.__proto__ || Object.getPrototypeOf(XoError)).apply(this, arguments));
  }

  return XoError;
}(_makeError.BaseError);

// -------------------------------------------------------------------

var Xo = function (_JsonRpcWebSocketClie) {
  _inherits(Xo, _JsonRpcWebSocketClie);

  function Xo(opts) {
    _classCallCheck(this, Xo);

    var url = opts && opts.url || '.';

    var _this2 = _possibleConstructorReturn(this, (Xo.__proto__ || Object.getPrototypeOf(Xo)).call(this, (url === '/' ? '' : url) + '/api/'));

    _this2._credentials = opts && opts.credentials || null;
    _this2._user = null;

    _this2.on(_jsonrpcWebsocketClient.OPEN, function () {
      if (_this2._credentials) {
        _this2._signIn(_this2._credentials).catch(noop);
      }
    });
    _this2.on(_jsonrpcWebsocketClient.CLOSED, function () {
      _this2._user = null;
    });
    return _this2;
  }

  _createClass(Xo, [{
    key: 'call',
    value: function call(method, args, i) {
      var _this3 = this;

      if ((0, _startsWith3.default)(method, 'session.')) {
        return Promise.reject(new XoError('session.*() methods are disabled from this interface'));
      }

      var promise = _get(Xo.prototype.__proto__ || Object.getPrototypeOf(Xo.prototype), 'call', this).call(this, method, args);
      promise.retry = function (predicate) {
        return promise.catch(function (error) {
          i = (i || 0) + 1;
          if (predicate(error, i)) {
            return _this3.call(method, args, i);
          }
        });
      };

      return promise;
    }
  }, {
    key: 'refreshUser',
    value: function refreshUser() {
      var _this4 = this;

      return _get(Xo.prototype.__proto__ || Object.getPrototypeOf(Xo.prototype), 'call', this).call(this, 'session.getUser').then(function (user) {
        return _this4._user = user;
      });
    }
  }, {
    key: 'signIn',
    value: function signIn(credentials) {
      // Register this credentials for future use.
      this._credentials = credentials;

      return this._signIn(credentials);
    }
  }, {
    key: '_signIn',
    value: function _signIn(credentials) {
      var _this5 = this;

      return _get(Xo.prototype.__proto__ || Object.getPrototypeOf(Xo.prototype), 'call', this).call(this, 'session.signIn', credentials).then(function (user) {
        _this5._user = user;
        _this5.emit('authenticated');
      }, function (error) {
        _this5.emit('authenticationFailure', error);
        throw error;
      });
    }
  }, {
    key: 'user',
    get: function get() {
      return this._user;
    }
  }]);

  return Xo;
}(_jsonrpcWebsocketClient2.default);

exports.default = Xo;
//# sourceMappingURL=index.js.map